import ClassicExtension from './ClassicExtension';

export default class TableExportExtension extends ClassicExtension {

    public init ($root): void {
        $root.find('table').each((i, el) => {
            const $table = $(el);

            if ($table.find('[data-table-export]').length === 0) {
                const $button = $('<button class="TableExport btn btn-sm btn-flat-default" title="Export CSV" data-table-export><i class="bi bi-download"></i></button>');
                $button.on('click', e => {
                    this.downloadCsv($table);
                })
                const $firstTr = $table.find('tr').first();
                const $lastCol = $firstTr.find('td,th').last();

                $lastCol.prepend($button);
            }
        });
    }

    private downloadCsv($table: JQuery) {

        const $rows = $table.find('tr');

        const separator = this.getSeparator();

        // Construct csv
        const csv = [];
        $rows.each((index, rowEl) => {

            const row = [], cols = rowEl.querySelectorAll('td, th');
            cols.forEach((col: HTMLElement) => {
                // Clean innertext to remove multiple spaces and jumpline (break csv)
                let data = col.innerText.replace(/(\r\n|\n|\r)/gm, '').replace(/(\s\s)/gm, ' ')
                // Escape double-quote with double-double-quote (see https://stackoverflow.com/questions/17808511/properly-escape-a-double-quote-in-csv)
                data = data.replace(/"/g, '""');

                row.push('"' + data + '"');
            });

            csv.push(row.join(separator));
        });

        const csv_string = '\ufeff'+csv.join('\n');

        // Download it
        var filename = 'export_table_' + (new Date()).toLocaleDateString() + '.csv';
        var link = document.createElement('a');
        link.style.display = 'none';
        link.setAttribute('target', '_blank');
        link.setAttribute('href', 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv_string));
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    private getSeparator(): ','|';' {
        const locale = navigator.language;
        const numberWithDecimal = 1.1;
        const formatted = new Intl.NumberFormat(locale).format(numberWithDecimal);

        const decimalSeparator = formatted.replace(/\d/g, '')[0];

        return decimalSeparator === ',' ? ';' : ',';
    }
}
